import React from 'react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';

export const DEFAULT_ACCENT = '#d97706';
const HEX = /^#[0-9a-fA-F]{6}$/;

const PdfSample = ({ color }) => (
  <div className="border rounded-md bg-white p-3 w-56" data-testid="company-accent-sample">
    <p className="text-[10px] uppercase tracking-wider text-neutral-400 mb-2">PDF title</p>
    <div className="flex items-start justify-between gap-2">
      <img src={`${process.env.REACT_APP_BACKEND_URL}/api/company-profile/email-logo.png`} alt="" className="h-8 w-auto max-w-[80px] object-contain" data-testid="company-accent-sample-logo" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
      <div className="text-right">
        <p className="text-lg font-bold leading-tight" style={{ color }} data-testid="company-accent-sample-title">INVOICE</p>
        <p className="text-[11px] font-semibold text-neutral-800">#INV-1001</p>
        <p className="text-[10px] text-neutral-500">Date: 2026-11-02</p>
      </div>
    </div>
    <p className="text-[10px] mt-2"><span className="font-semibold text-amber-600">Status: DRAFT</span> <span className="text-neutral-400">(status colours don't change)</span></p>
  </div>
);

const EmailSample = ({ color }) => (
  <div className="border rounded-md bg-white p-3 w-56" data-testid="company-accent-email-sample">
    <p className="text-[10px] uppercase tracking-wider text-neutral-400 mb-2">Email button</p>
    <p className="text-xs text-neutral-700 mb-2">Your quote is ready to review.</p>
    <span className="inline-block px-3 py-1.5 rounded text-xs font-semibold text-white" style={{ background: color }} data-testid="company-accent-sample-button">View Quote Details</span>
  </div>
);

export const AccentColorField = ({ value, onChange, disabled }) => {
  const shown = HEX.test(value || '') ? value : DEFAULT_ACCENT;
  return (
    <div className="space-y-3" data-testid="company-accent">
      <div className="flex flex-wrap items-center gap-3">
        <input type="color" value={shown} disabled={disabled} onChange={(e) => onChange(e.target.value)} className="h-10 w-14 rounded border cursor-pointer disabled:cursor-not-allowed" aria-label="Document accent colour" data-testid="company-accent-picker" />
        <Input value={value || ''} placeholder={DEFAULT_ACCENT} disabled={disabled} onChange={(e) => onChange(e.target.value.trim())} className="w-32 font-mono" maxLength={7} data-testid="company-accent-hex" />
        {!disabled && value && value.toLowerCase() !== DEFAULT_ACCENT && <Button type="button" size="sm" variant="ghost" onClick={() => onChange('')} data-testid="company-accent-reset">Use default</Button>}
        <span className="text-xs text-neutral-500" data-testid="company-accent-state">{value ? 'Custom colour · Save Company Profile to apply' : 'Default amber'}</span>
      </div>
      {value && !HEX.test(value) && <p className="text-xs text-red-600" data-testid="company-accent-error">Use a 6-digit hex colour like #d97706</p>}
      <div className="flex flex-wrap gap-3"><PdfSample color={shown} /><EmailSample color={shown} /></div>
    </div>
  );
};
